<template>
<div>
  <b-container>
    <b-row>
      <b-col md="6">
        <h1>Department</h1>

        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>

        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-form-group label="Name">
              <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                <b-form-input v-model="form.name" :state="errors[0] ? false : null"></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            
            <b-row>
              <b-col cols="8">
                <b-form-group label="Required Training" >
                  <b-form-select 
                    v-model="selectedEducationTypes" 
                    :options="listEducationTypes"
                    value-field="id"
                    text-field="name"
                    :select-size=10
                    multiple
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-button-group>
                  <b-button @click="openAddDialog" variant="primary"><b-icon icon="plus-square"></b-icon></b-button>
                  <b-button @click="removeEducationTypes" variant="outline-primary"><b-icon icon="dash-square"></b-icon></b-button>
                </b-button-group>
              </b-col>
            </b-row>

            <b-button variant="outline-secondary" class="mr-2" to="/department">Back</b-button>
            <b-button type="submit" variant="primary">Save</b-button>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>      
    
    <b-modal v-model="addDialog" title="Add" @ok="addEducationTypes" cancel-variant="outline-secondary">
      <b-form-group label="Required Training" >
        <b-form-select 
          v-model="selectedAddEducationTypes" 
          :options="listAddEducationTypes"
          value-field="id"
          text-field="name"
          :select-size=10
          multiple
        ></b-form-select>
      </b-form-group>
    </b-modal>

  </b-container>
</div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import axios from 'axios';

export default {
  components: { ValidationProvider, ValidationObserver },
  data() {
    return {
      form: {
        name: '',
        departmentRequiredEducationIds: []
      },
      educationTypes: [],
      selectedEducationTypes: [],
      addDialog: false,
      selectedAddEducationTypes: [],
      error: ''
    }
  },
  computed: {
    listAddEducationTypes() {
      return this.educationTypes.filter(type => { return !this.form.departmentRequiredEducationIds.includes(type.id); });
    },
    listEducationTypes() {
      return this.educationTypes.filter(type => { return this.form.departmentRequiredEducationIds.includes(type.id); });
    }
  },
  methods: {
    removeEducationTypes() {
      this.selectedEducationTypes.forEach(id => {
        const index = this.form.departmentRequiredEducationIds.indexOf(id);
        if (index > -1) {
          this.form.departmentRequiredEducationIds.splice(index, 1);
        }
      });
      this.selectedEducationTypes = [];
    },
    addEducationTypes() {
      this.selectedAddEducationTypes.forEach((id) => { this.form.departmentRequiredEducationIds.push(id); });
      this.selectedAddEducationTypes = [];
    },
    openAddDialog() {
      this.selectedAddEducationTypes = [];
      this.addDialog = true;
    },
    save() {
      this.error = '';

      axios.post('/api/departments', this.form)
      .then(() => {
        this.$router.push('/department')
        .catch(() => {
          this.error = 'Failed to save department';
        })
      })
    }
  },
  created() {
    axios.get('/api/educationtypes')
    .then(res => {
      this.educationTypes = res.data;
    })
  }
}
</script>